import { basePathInit } from '@/envConst';

export default (Vue) => {

  const http = Vue.prototype.$http;

  const basePath = basePathInit();

  var service = {
    easyLogin(params) {
      return http({
        baseDomain: basePath.bossapi.system,
        //url: 'ajax/easy/login.do',
        url: 'login.do',
        method: 'post',
        params  //用data传需要转成json， 用param传不有转json
      });
    },
    easyLogout(data) {
      return http({
        baseDomain: basePath.bossapi.system,
        url: 'ajax/easy/logout.do',
        method: 'post',
        data
      });
    },
    easyCheckToken(params) {
      return http({
        baseDomain: basePath.bossapi.system,
        url: 'ajax/easy/checkToken.do',
        method: 'get',
        params: params  //用data传需要转成json， 用param传不有转json
      });
    }
  };
  return service;
};